import { Component, ViewChild, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute, RouterLink } from "@angular/router";

import { ActionButtonComponent } from "../shared/action-button/action-button.component";
import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-reset",
	templateUrl: "./reset.component.html",
	styleUrls: ["./reset.component.scss"],
	imports: [FormsModule, ActionButtonComponent, RouterLink]
})
export class ResetComponent {
	private route = inject(ActivatedRoute);
	private api = inject(ApiService);

	@ViewChild("resetButton") resetButton: ActionButtonComponent;

	private email: string;
	private code: string;

	public password = "";
	public password2 = "";
	public mfaCode = "";
	public showMfa = false;

	public success = false;

	constructor() {
		this.route.queryParams.pipe(takeUntilDestroyed()).subscribe(params => {
			this.email = params["email"];
			this.code = params["code"];
		});
	}

	async Reset() {
		this.success = false;
		if (this.password !== this.password2) {
			throw new Error("Passwords must match");
		}
		try {
			await this.api.ResetPassword(this.email, this.code, this.password, this.mfaCode);
			this.success = true;
		} catch (err) {
			if (err?.status === 400 || err?.status === 401) {
				if (err.error?.message === "MFA code is required") {
					this.showMfa = true;
					setTimeout(() => {
						document.getElementById("mfa").focus();
					}, 100);
				} else {
					if (this.showMfa) {
						throw new Error("Invalid MFA code", { cause: err });
					} else {
						throw new Error("Invalid email or reset code", { cause: err });
					}
				}
			} else if (err?.status === 429) {
				throw new Error("Too many reset attempts. Please wait 15 minutes and try again.", { cause: err });
			} else {
				throw new Error("Reset failed", { cause: err });
			}
		}
	}

	CancelMfa() {
		this.mfaCode = "";
		this.showMfa = false;
		this.resetButton.problem = undefined;
	}
}
